import { Injectable } from '@angular/core';
import { PHBHPApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-api.service';

@Injectable({
  providedIn: 'root'
})
export class MyTaskService {
  constructor(private service: PHBHPApiService) { }
  userDetails: any;
  registerUser(data) {
    return this.service.postApi("UserProfile/AddUser", data, true);
  }
  AddUserOrSubscribe(data) {
    return this.service.postApi("UserProfile/AddUserOrSubscribe", data , true);
  }
  getUsersBountry(id) {
    return this.service.getApi("UserProfile/GetUsersBountryRolesAndInstitutions/"+id, true);
  }
  getUsernameExist(id) {
    return this.service.getApi("Users/UsernameExist/"+id, true);
  }
  getAllUsers(roleId) {
    return this.service.getApi("UserProfile/MyTask/"+roleId, true);
  }
  getCountriesKeyValuePair() {
    return this.service.getApi("countries/GetCountriesKeyValuePair", true);
  }
}
